"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../../styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        cell: {
            borderRight: "1px solid ".concat(palette.divider),
            borderBottom: "1px solid ".concat(palette.divider),
            padding: "".concat(spacing(), "px ").concat(spacing(2), "px ")
        },
        containerRoot: {
            height: '100%'
        }
    });
});
exports.default = useStyles;
